// cra only exposes REACT_APP_ prefixed variables to the browser bundle, a bare PL_ENV is always undefined here
export const isProd = process.env.REACT_APP_PL_ENV === 'prod'

const prodVariables = {
  API_BASE_URL: 'https://connect-api.playerslounge.co',
  APP_URL: 'https://app.playerslounge.com',
  APP_CMS: 'https://us-east-1.cdn.hygraph.com/content/ckbjhy22m02f001w9fz0bcbzv/master',
  WS_URL: 'wss://connect-api.playerslounge.co/socket',
  FARO_COLLECTOR_URL: process.env.REACT_APP_FARO_COLLECTOR_URL || 'https://app.playerslounge.com/api/telemetry/collect',
}

const devVariables = {
  API_BASE_URL: 'https://connect-staging-api.playerslounge.co',
  APP_URL: 'https://app-dev.playerslounge.com',
  APP_CMS: 'https://us-east-1.cdn.hygraph.com/content/ckbjhy22m02f001w9fz0bcbzv/development',
  WS_URL: 'wss://connect-staging-api.playerslounge.co/socket',
  FARO_COLLECTOR_URL: process.env.REACT_APP_FARO_COLLECTOR_URL || 'https://app-dev.playerslounge.com/api/telemetry/collect',
}

export const envVariables = isProd ? prodVariables : devVariables
